import { Component, computed, inject, input } from '@angular/core';
import { MultiPolygon, Point, Polygon } from 'app/shared/ll/models/geometry';
import { GOOGLE_API_KEY } from './google.tokens';


@Component({
    selector: 'google-image',
    styles: [
        `
        @media screen, print {
            .google-img {
                width: 100%;
                height: auto;
            }
        }
        `,
    ],
    template: `
        <img class="google-img" [src]="url()" [class.rounded-circle]="shape() == 'round'">
    `,
})
export class GoogleImageComponent {

    width = input.required<number>();

    height = input.required<number>();

    center = input.required<Point>();

    polygon = input.required<Polygon | MultiPolygon>();

    color = input('0xB1241CFF');

    fillColor = input('0xB1241C20');

    maptype = input<'roadmap' | 'satellite' | 'hybrid' | 'terrain'>('roadmap');

    shape = input<'round' | 'rectangle'>('rectangle');

    private googleApiKey = inject(GOOGLE_API_KEY);

    url = computed(() => {
        const query = `key=${this.googleApiKey}&size=${this.width()}x${this.height()}&maptype=${this.maptype()}`;
        let mapUrl = `https://maps.googleapis.com/maps/api/staticmap?${query}`;
        let polygonQuery = '';
        const polygon = this.polygon();
        const color = this.color();
        const fillColor = this.fillColor();
        const center = this.center();

        if (polygon.type === 'MultiPolygon') {
            const polygons: string[] = [];
            polygon.coordinates.forEach(poly => {
                const geo = poly[0].map(point => `${point[1]},${point[0]}`).join('|');
                polygons.push(`&path=color:${color}|weight:1|fillcolor:${fillColor}|${geo}`);
            });
            polygonQuery = polygons.join('');
        }

        if (polygon.type === 'Polygon') {
            const geo = polygon.coordinates[0].map(point => `${point[1]},${point[0]}`).join('|');
            polygonQuery = `&path=color:${color}|weight:1|fillcolor:${fillColor}|${geo}`;
        }

        mapUrl = mapUrl + polygonQuery;

        // google has a limit for an url length, if complicated polygon is selected, display marker instead
        if (polygonQuery.length > 7800 || polygonQuery.length === 0) {
            const [lng, lat] = center.coordinates;
            const marker = `color:${color}|label:|${lat},${lng}`;
            mapUrl = `https://maps.googleapis.com/maps/api/staticmap?${query}&markers=${marker}`;
        }
        return mapUrl;
    });
}
